<template>
	<div class="content">
		<el-tabs class="tabs" v-model="activeIndex" closable type="card" v-if="openTab.length" @tab-click='tabClick' @tab-remove='tabRemove'>
            <!-- <el-tab-pane :key="item.fullPath" v-for="item in openTab" :label="item.name" :name="item.fullPath" /> -->
			<el-tab-pane :key="item.fullPath" v-for="item in openTab" :name="item.fullPath">
                <el-tooltip v-if="item.tip" slot="label" effect="dark" :content="item.tip" placement="bottom-start">
                    <span>{{item.name}} <i class="el-icon-question"></i></span>
                </el-tooltip>
                <span v-else slot="label" >{{item.name}}</span>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>
<script>
	export default {
		props: {
			asideList: {
				type: Array
			}
		},
		data() {
			return {}
		},
		computed: {
			openTab() {
				return this.$store.state.openTab;
			},
			activeIndex: {
				get() {
					return this.$store.state.activeIndex;
				},
				set(val) {
					this.$store.commit('set_active_index', val);
				}
			}
		},
		watch: {
			'$route'(to, from) {
				//判断路由是否已经打开
				//已经打开的 ，将其置为active
				//未打开的，将其放入队列里
				let flag = false;
				for (let item of this.openTab) {
					if (item.fullPath === to.fullPath) {
						this.$store.commit('set_active_index', to.fullPath)
						flag = true;
						break;
					}
				}
				if (!flag) {
					this.$store.commit('add_tabs', {
						route: to.path,
						name: to.name,
                        fullPath: to.fullPath,
                        tip: to.meta.tip,
					});
					this.$store.commit('set_active_index', to.fullPath);
				}
			}
		},

		mounted() {
			if (this.$route.fullPath !== '/' && this.$route.fullPath !== '/home') {
				this.$store.commit('set_active_index', this.$route.fullPath);
			} else {
				this.$store.commit('delete_tabs', '/home');
				this.$store.commit('add_tabs', {
					route: '/home',
					name: '首页',
                    fullPath: '/home',
				});
				this.$store.commit('set_active_index', '/home');
				this.$router.push('/home');
			}
            this.$bus.$on('activeMenuName', (data) => {
                let tabArr = JSON.parse(JSON.stringify(this.openTab));
                tabArr.forEach(ele=> {
                    if(ele.fullPath === data.fullPath){
                        ele.name = data.name;
                    }
                });
                this.$store.commit('set_tabs', tabArr);
            });
		},

		methods: {
			//tab标签点击时，切换相应的路由
			tabClick(tab) {
				this.$router.push({
					path: this.activeIndex
				});
			},

			//移除tab标签
			tabRemove(targetName) {
				//首页不删
				if (targetName == '/' || targetName == '/home') {
					return
				}
				this.$store.commit('delete_tabs', targetName);
				if (this.activeIndex === targetName) {
					// 设置当前激活的路由
					if (this.openTab && this.openTab.length >= 1) {
						this.$store.commit('set_active_index', this.openTab[this.openTab.length - 1].fullPath);
						this.$router.push({
							path: this.activeIndex
						});
					} else {
						this.$router.push({
							path: '/'
						});
					}
				}
			}
		}
	}
</script>

<style scoped>
	/* .content {
		width: 100%;
		height: 55px;
		display: flex;
		align-items: center;
	}

	.tabs {
		height: 35px;
		margin-left: 10px;
	}

	/deep/.el-tabs__nav .el-tabs__item:nth-child(1) span {
		display: none;
	}

	/deep/.el-tabs__item {
		height: 35px;
		line-height: 35px;
	}

	/deep/.el-tabs--card>.el-tabs__header .el-tabs__item {
		border-bottom: 1px solid #E4E7ED;
	} */
</style>